export function dbscanGeo(points: any, epsKm = 1, minPoints = 2) {
    function haversineDistance(point1: any, point2: any) {
        const R = 6371;
        const lat1 = point1.latitude * Math.PI / 180;
        const lat2 = point2.latitude * Math.PI / 180;
        const dLat = (point2.latitude - point1.latitude) * Math.PI / 180;
        const dLon = (point2.longitude - point1.longitude) * Math.PI / 180;
        
        const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                  Math.cos(lat1) * Math.cos(lat2) *
                  Math.sin(dLon/2) * Math.sin(dLon/2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        
        return R * c;
    }
    
    const clusters: any = [];
    const visited = new Array(points.length).fill(false);
    const noise = [];
    
    function regionQuery(pointIdx: any) {
        const neighbors = [];
        for (let i = 0; i < points.length; i++) {
            if (haversineDistance(points[pointIdx], points[i]) <= epsKm) {
                neighbors.push(i);
            }
        }
        return neighbors;
    }
    
    function expandCluster(pointIdx: any, neighbors: any, clusterId: any) {
        clusters[clusterId].push(points[pointIdx]);
        visited[pointIdx] = true;
        
        let i = 0;
        while (i < neighbors.length) {
            const currentIdx = neighbors[i];
            
            if (!visited[currentIdx]) {
                visited[currentIdx] = true;
                const currentNeighbors = regionQuery(currentIdx);
                
                if (currentNeighbors.length >= minPoints) {
                    for (let n of currentNeighbors) {
                        if (!neighbors.includes(n)) {
                            neighbors.push(n);
                        }
                    }
                }
            }
            
            if (!clusters[clusterId].includes(points[currentIdx])) {
                clusters[clusterId].push(points[currentIdx]);
            }
            i++;
        }
    }
    
    let clusterId = 0;
    for (let i = 0; i < points.length; i++) {
        if (!visited[i]) {
            const neighbors = regionQuery(i);
            
            if (neighbors.length < minPoints) {
                noise.push(points[i]);
            } else {
                clusters.push([]);
                expandCluster(i, neighbors, clusterId);
                clusterId++;
            }
        }
    }
    
    const largestCluster = clusters.reduce((max: any, cluster: any) => 
        cluster.length > max.length ? cluster : max, []);
    
    return {
        clusters: clusters,
        largestCluster: largestCluster,
        largestClusterSize: largestCluster.length,
        noise: noise,
        totalClusters: clusters.length
    };
}